import { Point, Point3d, PointUtilities, ScanZone, ViewportImage } from '@ng-cloud/badger-core';

export enum LocationType {
  RFID = 'rfid',
  TOP_STOCK = 'top_stock',
  VIEWPORT = 'viewport'
}

export class ProductLocation {
  id: number;
  locationType: string;
  viewportId: number;
  scanEventId: number;
  storePolygon: Point3d[];
  shelfPolygon: Point[];
  lastSeen: Date;
  viewportImages: ViewportImage[];
  rfidScanEventId: number;
  scanZone: ScanZone;
  epc: string;
  serialNumber: string;
  x: number;
  y: number;
  z: number;
  imageId: number;
  imagePolygon: any;

  deserialize(json: any, localId: number): this {
    this.id = localId;
    this.locationType = json.location_type;
    this.viewportId = json.viewport_id;
    this.scanEventId = json.scan_event_id;
    this.lastSeen = json.last_seen && new Date(json.last_seen);
    this.epc = json.epc;
    this.storePolygon = json.store_polygon && PointUtilities.toPoint3dArray(json.store_polygon);
    this.shelfPolygon = json.shelf_polygon && PointUtilities.toPointArray(json.shelf_polygon);
    this.viewportImages = json.viewport_images ? json.viewport_images.map((viewportImage: any) => new ViewportImage().deserialize(viewportImage)) : [];
    this.rfidScanEventId = json.rfid_scan_event_id;
    this.x = json.x;
    this.y = json.y;
    this.z = json.z;
    this.imageId = json.image_id;
    this.imagePolygon = json.image_polygon;

    if (json.scan_zone) {
      json.scan_zone.points = PointUtilities.toPointArray(json.scan_zone.points);
      this.scanZone = new ScanZone().deserialize(json.scan_zone);
    }

    if (this.locationType === LocationType.TOP_STOCK) {
      this.storePolygon = json.store_polygon;
      this.shelfPolygon = json.shelf_polygon;

      const image = json.image_file && new ViewportImage().deserialize(json.image_file);
      
      if (image) {
        image.viewportLocation = this.imagePolygon;
        this.viewportImages.push(image);
      }
    }

    return this;
  }
}
